import http from "./http";

export const getAdminDashboardData = (params = {}) =>
  http.get("/auth/dashboard/admin/", { params });
